module.exports = __webpack_public_path__ + "img/btn-gotohere.b76beff2.png";